<template>
  <div>
    <div v-if="box_model_buttons.length" class="model-category">
      <div class="model-category-label">
        <v-icon size="16">fa-sharp fa-light fa-boxes-stacked</v-icon>
        <span>{{ $t('models_and_train_configs.friendly_category_boxes') }}</span>
      </div>
      <model-buttons
        :disabled="disabled"
        @on_click="on_click"
        :model_buttons="box_model_buttons"
        :selected_model_type="selected_model_type"
      />
    </div>
    <div v-if="classification_model_buttons.length" class="model-category">
      <div class="model-category-label">
        <v-icon size="16">fa-solid fa-image</v-icon>
        <span>{{ $t('models_and_train_configs.friendly_category_classify') }}</span>
      </div>
      <model-buttons
        :disabled="disabled"
        @on_click="on_click"
        :model_buttons="classification_model_buttons"
        :selected_model_type="selected_model_type"
      />
    </div>
    <div v-if="text_model_buttons.length" class="model-category">
      <div class="model-category-label">
        <v-icon size="16">fa-solid fa-font</v-icon>
        <span>{{ $t('models_and_train_configs.friendly_category_ocr') }}</span>
      </div>
      <model-buttons
        :disabled="disabled"
        @on_click="on_click"
        :model_buttons="text_model_buttons"
        :selected_model_type="selected_model_type"
      />
    </div>
  </div>
</template>

<script>
import ModelButtons from "@/components/train_configs/ModelButtons.vue";

export default {
  name: "ModelButtonOverview",
  components: { ModelButtons },
  props: {
    model_buttons: { required: true },
    selected_model_type: { required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    box_model_buttons() {
      return this.model_buttons.filter((button) => button.type === 'bounding_box');
    },
    classification_model_buttons() {
      return this.model_buttons.filter((button) => button.type === 'classification');
    },
    text_model_buttons() {
      return this.model_buttons.filter((button) => button.type === 'ocr');
    },
  },
  methods: {
    on_click(selected_model_button) {
      this.$emit('clicked', selected_model_button);
    },
  },
};
</script>

<style scoped>
.model-category {
  margin-bottom: 10px;
  clear: both;
  overflow: hidden;
}

.model-category-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #546e7a;
  margin-bottom: 6px;
}
</style>
